const MS_PER_HOUR = 60 * 60 * 1000;

/**
 * Clipper-facing accrual cutoff. Matches backend `isPastAccrualWindow`:
 * `now === windowEnd` is still inside the window. `0` / missing hours means
 * unlimited, so the card must not claim the window has closed.
 */
export function isAccrualWindowClosed({
  submittedAt,
  windowHours,
  now,
}: {
  submittedAt?: string | null;
  windowHours?: number | null;
  now: Date;
}): boolean {
  if (windowHours == null || windowHours <= 0) return false;
  if (!submittedAt) return false;
  const start = new Date(submittedAt);
  if (Number.isNaN(start.getTime())) return false;
  return now.getTime() > start.getTime() + windowHours * MS_PER_HOUR;
}
